import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { createActions } from "reduxsauce";

var _createActions = createActions({
  accountData: function accountData(account) {
    return {
      type: "LOYALTY_ACCOUNT_DATA",
      account: _objectSpread(_objectSpread({}, account), {}, {
        receivedAt: Date.now()
      }),
      receivedAt: Date.now()
    };
  },
  resetAccountData: function resetAccountData() {
    return {
      type: "LOYALTY_RESET_ACCOUNT_DATA",
      account: {
        receivedAt: Date.now()
      },
      receivedAt: Date.now()
    };
  },
  setPersonalizationModals: function setPersonalizationModals(show) {
    return {
      type: "LOYALTY_SET_PERSONALIZATION_MODALS",
      showPersonalizationModal: show
    };
  },
  setTransactionLimitInfo: function setTransactionLimitInfo(info) {
    return {
      type: "LOYALTY_SET_TRANSACTION_LIMIT_INFO",
      transactionLimitInfo: info
    };
  },
  setErrorMessage: function setErrorMessage(show) {
    return {
      type: "LOYALTY_SET_ERROR_MESSAGE",
      hasLoginError: show
    };
  }
}, {
  prefix: "LOYALTY_"
}),
    Creators = _createActions.Creators,
    Types = _createActions.Types;

export default {
  Creators: Creators,
  Types: Types
};